import Logo from "@/components/Logo";
import { CALENDLY_URL } from "@/lib/scroll";

const LINKS = [
  { label: "The Problem", href: "#problem" },
  { label: "Deliverables", href: "#deliverables" },
  { label: "7-Day Sprint", href: "#process" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

const Footer = () => (
  <footer className="border-t border-white/10 bg-ink py-12 text-cream/50">
    <div className="mx-auto flex max-w-7xl flex-col justify-between gap-10 px-4 sm:px-6 md:flex-row md:items-center lg:px-12">
      <div>
        <Logo dark />
        <p className="mt-4 max-w-xs text-sm leading-relaxed">
          Structured outbound, built and tested in 7 days for B2B service founders.
        </p>
      </div>
      <nav className="flex flex-wrap gap-x-6 gap-y-3">
        {LINKS.map((l) => (
          <a
            key={l.href}
            href={l.href}
            data-testid={`footer-link-${l.href.slice(1)}`}
            onClick={(e) => {
              e.preventDefault();
              document.querySelector(l.href)?.scrollIntoView({ behavior: "smooth" });
            }}
            className="text-sm transition-colors hover:text-cream"
          >
            {l.label}
          </a>
        ))}
        <a
          href={CALENDLY_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-cta"
          className="text-sm font-medium text-terra transition-colors hover:text-gold"
        >
          Book a fit call
        </a>
      </nav>
      <p className="font-mono text-xs tracking-wide">
        © {new Date().getFullYear()} Sell With Abhi. All rights reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
